import _ from 'lodash';
import CustomerStore from '../stores/CustomerStore';

const isBrowser = (typeof window !== 'undefined');
let identifyCalledMap = {};

function AnalyticsPlugin(options={}) {
  let host = options.host;
  return {
    name: 'AnalyticsPlugin',

    plugContext(contextOptions, context) {
      let deviceId = contextOptions.deviceId;
      let version = contextOptions.version;

      let getEnvironmentProps = (context) => {
        let useragent = context.getUserAgent();
        return {
          os: (useragent.isiOs ? 'ios' : (useragent.isAndroid ? 'android' : (useragent.isMac ? 'osx' : (useragent.isWindows ? 'windows' : useragent.os)))),
          os_version: null,
          form_factor: (useragent.isMobile ? 'phone' : (useragent.isTablet ? 'tablet' : 'desktop')),
          platform: 'web',
          app: host,
          app_version: version,
        };
      };

      let identify = (customer, force=false) => {
        if(customer && (!identifyCalledMap[customer.id] || force) && (typeof analytics !== 'undefined')) {
          analytics.identify(customer.id, {
            name: customer.name,
            email: customer.email,
            phone: customer.phone,
            device_id: deviceId
          });
          identifyCalledMap[customer.id] = true;
        }
      };

      let trackEvent = (context, event, properties={}) => {
        if(!isBrowser) {return;}
        let currentStore = context.getCurrentStore();
        let currentCustomer = context.getStore(CustomerStore).getCurrentCustomer();

        identify(currentCustomer);

        let finalProps = _.extend(getEnvironmentProps(context), {
          timestamp: new Date(),
          auth_status: currentCustomer ? currentCustomer.authStatus() : null,
          device_id: deviceId,
          customer_id: currentCustomer ? currentCustomer.id : null,
          nux_variant: null,
          shop_variant: null,
          saved_variant: null,
          cart_variant: null,
          store_id: currentStore ? currentStore.id : null
        }, properties);

        if(typeof analytics !== 'undefined') {
          switch(event) {
            case 'view':
              analytics.page(properties.value);
              break;
            case 'search':
              analytics.track('Products Searched', {query: properties.value});
              break;
          }
          analytics.track(event, finalProps);
        }
      };

      return {
        plugActionContext(actionContext) {
          actionContext.getEnvironmentProps = () => {
            return getEnvironmentProps(actionContext);
          };

          actionContext.trackEvent = (event, properties) => {
            return trackEvent(actionContext, event, properties);
          };

          actionContext.identify = identify;
        },

        plugComponentContext(componentContext) {
          componentContext.trackEvent = (event, properties) => {
            return trackEvent(componentContext, event, properties);
          };
        },

        dehydrate() {
          return {
            deviceId: contextOptions.deviceId,
            version: contextOptions.version
          };
        },

        rehydrate(state) {
          deviceId = state.deviceId;
          version = state.version;
        }
      };
    }
  };
}

export default AnalyticsPlugin;



// WEBPACK FOOTER //
// banquet/plugins/AnalyticsPlugin.js